import React from "react";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import TimelineData from "../misc/TimelineData"

function WorkTimeline() {
  return (
    <div className="mt-5" id="timeline">
      <hr
        style={{
          color: "#0b032d",
          backgroundColor: "#0b032d",
          height: 1,
          opacity: "50%"
        }}
      />
      <h1> Časová os práce </h1>
      <Timeline lineColor={"#ddd"}>
        {TimelineData.map((item, index) => {return <TimelineItem
          key = {index}
          dateText={item.date}
          dateInnerStyle={{ background: "#0b032d", color: "#f67e7d" }}
          bodyContainerStyle={{
            background: "#ddd",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
          }}
        >
          <h3 style={{ color: "#0b032d" }}>{item.title}</h3>
          <h4 style={{ color: "#0b032d" }}>{item.place}</h4>
          <p>
           {item.text}
          </p>
          <img
            src={item.image}
            className="w-75"
            alt="Team pic"
          ></img>
        </TimelineItem>})}
      </Timeline>
    </div>
  );
}

export default WorkTimeline;
